import React, { FC } from 'react';
import { Wrap } from '@fiverr-private/layout_components';
import { translate as t } from '@fiverr-private/i18n-react';
import { FormControl } from '@fiverr-private/orca';
import { T_FORM_KEY } from '../../../utils';
import { DatesFieldProps } from '../../../shared/types';
import Months from './Months';
import Years from './Years';

const DatesField: FC<DatesFieldProps> = ({
    control,
    currentlyWorking,
    errors,
    getValues,
    setError,
    clearErrors,
    setValue,
    trigger,
}) => {
    const monthsProps = {
        control,
        errors,
        getValues,
        setError,
        clearErrors,
        setValue,
        trigger,
        currentlyWorking,
    };

    const yearsProps = {
        control,
        errors,
        getValues,
        setError,
        clearErrors,
        setValue,
        trigger,
        currentlyWorking,
    };

    return (
        <>
            <FormControl label={t(`${T_FORM_KEY}.fields.dates.start_label`)}>
                <Wrap>
                    <Months isStart {...monthsProps} />
                    <Years isStart {...yearsProps} />
                </Wrap>
            </FormControl>
            <FormControl label={t(`${T_FORM_KEY}.fields.dates.end_label`)}>
                <Wrap>
                    <Months {...monthsProps} />
                    <Years {...yearsProps} />
                </Wrap>
            </FormControl>
        </>
    );
};

export default DatesField;
